import { makeStyles } from "@fluentui/react-components";
import designTokens from "theme/customTheme";

export const useManageAnnouncementsStyles = makeStyles({
  truncatedText: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  htmlContent: {
    maxHeight: "60px",
    overflow: "hidden",
    fontSize: designTokens.fontSize.sm,
    lineHeight: designTokens.lineHeight.normal,
    "& p": {
      margin: 0,
    },
    "& a": {
      color: designTokens.primary[600],
    },
  },
});
